import { render, staticRenderFns } from "./PValue.vue?vue&type=template&id=a9493c34&scoped=true&"
import script from "./PValue.vue?vue&type=script&lang=ts&"
export * from "./PValue.vue?vue&type=script&lang=ts&"
import style0 from "./PValue.vue?vue&type=style&index=0&id=a9493c34&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9493c34",
  null
  
)

export default component.exports